export default __webpack_public_path__ + "static/media/pakrap-10.1b9238c5.mp3";